module.exports = __webpack_public_path__ + "img/xl_nx.13bf6933.png";